import { render, staticRenderFns } from "./AddManagementHistory.vue?vue&type=template&id=59a58713&scoped=true&"
import script from "./AddManagementHistory.vue?vue&type=script&lang=js&"
export * from "./AddManagementHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a58713",
  null
  
)

export default component.exports